














import { Component, Prop, Vue } from 'vue-property-decorator';
import navbar from '@/components/navigation-bar.vue';
import sidebar from '@/components/navigation-sidebar.vue';

@Component({
    components: {
        navbar,
        sidebar,
    },
})
export default class BasicLayout extends Vue {}
